import React, { useState } from "react";
import { auth, db } from "../firebase/config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";

const CHURCHES = ["Victory Pasig"];

export default function FacilitatorRegister() {
  const [formData, setFormData] = useState({
    firstName: "", lastName: "", email: "",
    password: "", confirmPassword: "",
    birthday: "", phone: "", church: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  function handleChange(e) {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  }

  async function handleRegister(e) {
    e.preventDefault();
    setError("");
    if (!formData.church) return setError("Please select your church.");
    if (formData.password !== formData.confirmPassword) return setError("Passwords do not match.");
    if (formData.password.length < 6) return setError("Password must be at least 6 characters.");
    setLoading(true);
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, formData.email, formData.password);
      const user = userCredential.user;
      await setDoc(doc(db, "users", user.uid), {
        firstName: formData.firstName, lastName: formData.lastName,
        email: formData.email, birthday: formData.birthday,
        phone: formData.phone, church: formData.church,
        role: "facilitator", status: "pending",
        createdAt: new Date().toISOString(),
      });
      navigate("/pending");
    } catch (err) {
      setError(err.code === "auth/email-already-in-use" ? "This email is already registered." : "Registration failed. Please try again.");
      setLoading(false);
    }
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Poppins:wght@600;700&family=Outfit:wght@400;500;600;700;800&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        .fr-wrap { display: flex; min-height: 100vh; }
        .fr-left { width: 38%; background: #060D1A; display: flex; flex-direction: column; justify-content: space-between; padding: 56px 48px; position: relative; overflow: hidden; }
        .fr-right { flex: 1; background: #ffffff; display: flex; flex-direction: column; justify-content: space-between; padding: 48px 56px; overflow-y: auto; }
        .fr-rings { position: absolute; bottom: -120px; right: -120px; width: 520px; height: 520px; pointer-events: none; }
        .fr-ring { position: absolute; border-radius: 50%; transform: translate(-50%, -50%); top: 50%; left: 50%; }
        .fr-tag { display: inline-block; background: rgba(201,168,76,0.1); border: 1px solid rgba(201,168,76,0.25); color: #C9A84C; font-family: 'Outfit', sans-serif; font-size: 10px; font-weight: 600; padding: 4px 12px; border-radius: 999px; letter-spacing: 1px; text-transform: uppercase; margin-bottom: 20px; }
        .fr-input { width: 100%; padding: 12px 16px; border-radius: 12px; border: 2px solid #e8e8e8; background: #f5f5f5; font-size: 14px; font-family: 'Outfit', sans-serif; color: #0A1628; }
        .fr-input:focus { border-color: #C9A84C; outline: none; background: #fff; }
        .fr-select { width: 100%; padding: 12px 16px; border-radius: 12px; border: 2px solid #e8e8e8; background: #f5f5f5; font-size: 14px; font-family: 'Outfit', sans-serif; color: #0A1628; appearance: auto; }
        .fr-label { font-family: 'Outfit', sans-serif; font-size: 11px; font-weight: 600; color: #777; text-transform: uppercase; letter-spacing: 1px; margin-bottom: 6px; display: block; }
        .fr-row { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; }
        .submit-btn { width: 100%; padding: 15px; border-radius: 12px; background: #C9A84C; color: #060D1A; border: none; font-family: 'Outfit', sans-serif; font-size: 15px; font-weight: 700; letter-spacing: 1px; text-transform: uppercase; cursor: pointer; margin-top: 8px; }
        .fr-mobile-top { display: none; background: #060D1A; padding: 32px 24px 28px; }
        @media (max-width: 768px) {
          .fr-wrap { flex-direction: column; }
          .fr-left { display: none; }
          .fr-mobile-top { display: block; }
          .fr-right { padding: 32px 24px 40px; }
          .fr-row { grid-template-columns: 1fr; }
        }
      `}</style>
      <div className="fr-wrap">
        <div className="fr-mobile-top">
          <div className="fr-tag">Facilitator Registration</div>
          <div style={{ marginBottom: 8 }}>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#fff" }}>LEAD</span>
            <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 48, fontWeight: 600, color: "#0038A8" }}>NOW</span>
          </div>
          <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#C9A84C", margin: 0, fontWeight: 600 }}>A leadership development program of LGU of Pasig and Victory Pasig</p>
        </div>
        <div className="fr-left">
          <div className="fr-rings">
            <div className="fr-ring" style={{ width: 100, height: 100, border: "1px solid rgba(201,168,76,0.2)" }} />
            <div className="fr-ring" style={{ width: 210, height: 210, border: "1px solid rgba(201,168,76,0.15)" }} />
            <div className="fr-ring" style={{ width: 340, height: 340, border: "1px solid rgba(255,255,255,0.12)" }} />
            <div className="fr-ring" style={{ width: 500, height: 500, border: "1px solid rgba(255,255,255,0.07)" }} />
            <div className="fr-ring" style={{ width: 8, height: 8, background: "rgba(201,168,76,0.4)", border: "none" }} />
          </div>
          <div style={{ position: "relative", zIndex: 1 }}>
            <div className="fr-tag">Facilitator Registration</div>
            <div style={{ marginBottom: 16 }}>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 56, fontWeight: 600, color: "#fff" }}>LEAD</span>
              <span style={{ fontFamily: "'Poppins', sans-serif", fontSize: 56, fontWeight: 600, color: "#0038A8" }}>NOW</span>
            </div>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 12, color: "#C9A84C", margin: 0, fontWeight: 600 }}>A leadership development program of<br />LGU of Pasig and Victory Pasig</p>
          </div>
          <div style={{ position: "relative", zIndex: 1 }}>
            <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 13, color: "rgba(255,255,255,0.35)", margin: 0 }}>
              Already have an account? <Link to="/login" style={{ color: "#C9A84C", fontWeight: 600, textDecoration: "none" }}>Sign In</Link>
            </p>
          </div>
        </div>
        <div className="fr-right">
          <div style={{ width: "100%", maxWidth: 480, margin: "auto" }}>
            <div style={{ marginBottom: 28 }}>
              <h2 style={{ fontFamily: "'Outfit', sans-serif", fontSize: 26, fontWeight: 700, color: "#060D1A", marginBottom: 6 }}>Create your facilitator account.</h2>
              <p style={{ fontFamily: "'Outfit', sans-serif", fontSize: 14, color: "#aaa" }}>Fill in your details to join the LEADNOW team.</p>
            </div>
            <form onSubmit={handleRegister} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
              <div className="fr-row">
                <div><label className="fr-label">First Name</label><input className="fr-input" type="text" name="firstName" value={formData.firstName} onChange={handleChange} placeholder="First name" required /></div>
                <div><label className="fr-label">Last Name</label><input className="fr-input" type="text" name="lastName" value={formData.lastName} onChange={handleChange} placeholder="Last name" required /></div>
              </div>
              <div><label className="fr-label">Email</label><input className="fr-input" type="email" name="email" value={formData.email} onChange={handleChange} placeholder="your@email.com" required /></div>
              <div>
                <label className="fr-label">Church</label>
                <select className="fr-select" name="church" value={formData.church} onChange={handleChange} required>
                  <option value="">Select your church</option>
                  {CHURCHES.map((c) => (<option key={c} value={c}>{c}</option>))}
                </select>
              </div>
              <div className="fr-row">
                <div><label className="fr-label">Birthday</label><input className="fr-input" type="date" name="birthday" value={formData.birthday} onChange={handleChange} required /></div>
                <div><label className="fr-label">Phone Number</label><input className="fr-input" type="tel" name="phone" value={formData.phone} onChange={handleChange} placeholder="09171234567" required /></div>
              </div>
              <div className="fr-row">
                <div><label className="fr-label">Password</label><input className="fr-input" type="password" name="password" value={formData.password} onChange={handleChange} placeholder="••••••••" required /></div>
                <div><label className="fr-label">Confirm</label><input className="fr-input" type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="••••••••" required /></div>
              </div>
              {error && <p style={{ color: "#e53935", fontSize: 13, textAlign: "center" }}>{error}</p>}
              <button type="submit" className="submit-btn" disabled={loading}>{loading ? "Creating Account..." : "Create Facilitator Account"}</button>
            </form>
          </div>
          <p style={{ fontFamily: "'Outfit', sans-serif", textAlign: "center", fontSize: 9, color: "rgba(0,0,0,0.15)", letterSpacing: 1, textTransform: "uppercase", marginTop: 24 }}>© 2026 GOSECOND INC. All rights reserved.</p>
        </div>
      </div>
    </>
  );
}
